<div class="ui container">
  <h1 class="ui header inverted">
    <i class="bell icon" [class.orange]="newNotificationsCount"></i>
    <div class="content">
      Notifications
    </div>
  </h1>

  <a *ngIf="newNotificationsCount" class="ui inverted blue button" [routerLink]="['.']">
    + {{ newNotificationsCount }} new notifications...
  </a>

  <p *ngIf="!newNotificationsCount && !unreadNotificationsList.length && !readNotificationsList.length">
    You have no notifications
  </p>


  <div class="ui inverted segment notifications-container">
    <div class="ui inverted very relaxed divided list">
      <a class="link item" *ngFor="let item of unreadNotificationsList" [routerLink]="[item.link]">
        <i class="orange icon" [ngClass]="item.icon"></i>
        <div class="content">
          <div class="header">
            {{ item.header }}
          </div>
          <div class="description">
            {{ item.timeAgo }}
          </div>
        </div>
      </a>
      <a class="link item" *ngFor="let item of readNotificationsList" [routerLink]="[item.link]">
        <i class="icon" [ngClass]="item.icon"></i>
        <div class="content">
          <div class="header">
            {{ item.header }}
          </div>
          <div class="description">
            {{ item.timeAgo }}
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
